<template>
<v-container fill-height>
    <v-layout align-center justify-center>

        <v-flex v-if="tokenIsValid" style="max-width: 600px;">

            <form @keyup.enter.prevent="reset" v-if="!success">
                <v-card color="grey lighten-3">
                    <v-card-title primary-title>
                        <h1 style="width: 100%; text-align: center;">Type in a new Password</h1>
                    </v-card-title>
                    <v-card-text style="padding: 2rem;">
                        <div v-if="laravelErrors.active" class="text-xs-center">
                            <v-chip label color="red" text-color="white">{{ laravelErrors.message }}</v-chip>
                        </div>
                        <v-text-field class="mt-5" type="password" name="password" v-model="password" label="Password" prepend-icon="lock" v-validate="'required|min:8'">
                        </v-text-field>
                        <div class="error--text text-xs-center">{{ errors.first('password') }}</div>
                        <v-text-field prepend-icon="lock" type="password" v-model="passwordRetype" label="Retype Password">
                        </v-text-field>
                        <div class="green--text text-xs-center" v-if="passwordsCheck.match">Passwords match</div>
                        <div class="error--text text-xs-center" v-if="passwordsCheck.nomatch">Passwords don't match</div>
                        <v-spacer class="my-4"></v-spacer>
                        <v-btn @click="reset" :loading="loading">Reset</v-btn>
                    </v-card-text>
                </v-card>
            </form>

            <v-card v-else color="grey lighten-3">
                <v-card-title primary-title class="d-block">
                    <h1 class="green--text text-xs-center">Success!</h1>
                </v-card-title>
                <v-card-text>
                    <p class="title mb-5">You've successfully updated your password, please proceed to the home page and login!</p>
                    <v-flex sm4 offset-sm4 d-flex justify-center>
                        <v-btn color="green" class="white--text" large to="/">Home</v-btn>
                    </v-flex>
                </v-card-text>
            </v-card>

        </v-flex>

        <v-flex v-else style="max-width: 600px;">
            <v-card color="grey lighten-3">
                <v-card-title primary-title class="d-block">
                    <h1 class="red--text text-xs-center">Invalid Link</h1>
                </v-card-title>
                <v-card-text>
                    <p class="title px-5">Sorry this link is invalid or has expired. If you are trying to reset your password please fill out another <router-link to="/">request</router-link>
                    </p>
                </v-card-text>
            </v-card>

        </v-flex>

    </v-layout>
</v-container>
</template>

<script>
import axios from 'axios'
import throttle from 'lodash.throttle'

export default {
    data() {
        return {
            tokenIsValid: false,
            password: '',
            passwordRetype: '',
            userID: 0,
            token: '',
            success: false,
            loading: false
        }
    },
    beforeRouteEnter(to, from, next) {
        let url = `/api/password/validate/token?id=${to.query.id}&token=${to.query.token}`
        next(vm => {
            axios.post(url).then((response) => {
                    vm.tokenIsValid = response.data.valid
                    vm.userID = to.query.id
                    vm.token = to.query.token
                })
                .catch((e) => {
                    vm.tokenIsValid = false
                })
        })
    },
    computed: {
        passwordsCheck() {
            let match = (this.password === this.passwordRetype)
            let empty = (this.passwordRetype.length === 0)
            return {
                match: (match && !empty),
                nomatch: (!match && !empty)
            }
        },
        laravelErrors() {
            return this.$store.state.errorModule.general
        }
    },
    methods: {
        reset: throttle(function () {
            this.loading = true
            this.$store.commit('clearErrors')

            this.$validator.validate('password').then((result) => {
                if (result && this.passwordsCheck.match) {
                    let resetData = {
                        userID: this.userID,
                        password: this.password,
                        password_confirmation: this.passwordRetype,
                        token: this.token
                    }
                    // timer is for UX, so user knows button was clicked and form was submitted
                    setTimeout(() => {
                        this.$store.dispatch('resetPassword', resetData)
                            .then(() => this.success = true)
                            .catch(() => this.loading = false)
                    }, 500)
                } else {
                    this.loading = false
                }
            })
        }, 1000)
    }
}
</script>
